import { Steps, Step } from 'components/Docs/Steps';
import * as React from 'react';
export default {
  Steps,
  Step,
  React
};